import useShouldRenderDeleteCatalog from "@components/Actions/useShouldRenderDeleteCatalog";
import PageDataContextService from "@core-ui/ContextServices/PageDataContext";
import WorkspaceService from "@core-ui/ContextServices/Workspace";
import { usePlatform } from "@core-ui/hooks/usePlatform";
import PermissionService from "@ext/security/logic/Permission/components/PermissionService";
import { configureCatalogPermission } from "@ext/security/logic/Permission/Permissions";

export interface CatalogDeleteConditions {
	canDelete: boolean;
	isEditorApp: boolean;
	isSpace: boolean;
	isPublished: boolean;
	canConfigureCatalog: boolean;
}

export const getCatalogDeleteOptions = ({
	canDelete,
	isEditorApp,
	isSpace,
	isPublished,
	canConfigureCatalog,
}: CatalogDeleteConditions) => {
	const inSpace = canDelete && isEditorApp && isSpace && isPublished;
	return { plain: canDelete && !inSpace, fromDevice: inSpace, fromSpace: inSpace && canConfigureCatalog };
};

const useCatalogDeleteOptions = (catalogName: string, isPublished: boolean) => {
	const canDelete = useShouldRenderDeleteCatalog();
	const { isWeb, isTauri } = usePlatform();
	const workspace = WorkspaceService.current();
	const { enabled, url } = PageDataContextService.value.conf.enterpriseCloud;
	const canConfigureCatalog = PermissionService.useCheckPermission(
		configureCatalogPermission,
		workspace?.path,
		catalogName,
	);

	return getCatalogDeleteOptions({
		canDelete,
		isEditorApp: isWeb || isTauri,
		isSpace: !!workspace?.enterprise?.gesUrl || (enabled && !!url),
		isPublished,
		canConfigureCatalog,
	});
};

export default useCatalogDeleteOptions;
